import React from "react";
import { Dropdown, NavigationMenu, useAppConfig } from "@fdoh/health-ui-react";
import { Link } from "react-router-dom";
import IconUser from "./icons/IconUser";
import useProfile from "./hooks/useProfile";
import { UserSecurityInput } from "./components/DBProtectedRoute.types";
import useData from "./hooks/useData";
import { UserList } from "./pages/UserManagement/UserManagement.types";
// import { useData } from "./hooks";

const IconHome = React.lazy(
  () => import("./icons/IconHome" /* webpackChunkName: "iconHome" */)
);
const IconPlus = React.lazy(
  () => import("./icons/IconPlus" /* webpackChunkName: "iconPlus" */)
);
const IconUsers = React.lazy(
  () => import("./icons/IconUsers" /* webpackChunkName: "iconUsers" */)
);

export const MenuItems = () => {
  const config = useAppConfig();
      const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
      const user =  useProfile(application) as UserSecurityInput;
      //const userList= useData<UserList[]>('UserSecurity/getlistofactiveusers' );
  //const roles = useData<string[]>("me/roles");
  const DownloadFile =  () =>
  {
      
  
  
      const options = {
          method: "GET",
          headers: { "Content-Type": "application/json" }
      };
  
      var fileName = "Private Inspection Portal Instruction Manual.pdf";
      var filePath = "wwwroot/InstructionManualFile/";
      let path = `${application.baseUrl}/ApplicationInspection/GetFileById/`+fileName + "?uploadPath="+filePath;
      const response = fetch(path, options)
      .then(response => {
          response.blob().then(blob => {
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement('a');
              a.href = url;
              a.download = fileName;
              a.click();
          });
  
  });
}

  return (
    <>
      <NavigationMenu.Item href="/" icon={<IconHome />} label="Home" />
      <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#navbar-base" data-bs-toggle="dropdown" data-bs-auto-close="outside" role="button" aria-expanded="false">
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <svg className="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5"></path><path d="M12 12l8 -4.5"></path><path d="M12 12l0 9"></path><path d="M12 12l-8 -4.5"></path><path d="M16 5.25l-8 4.5"></path></svg>
                    </span>
                    <span className="nav-link-title">
                      System Support
                    </span>
                  </a>
                  <div className="dropdown-menu">
                    <div className="dropdown-menu-columns">
                      <div className="dropdown-menu-column">
                        <a className="dropdown-item" href="./supportRequest">
                         Support Request
                        </a>
                        <div className="dropend">
                          <a className="dropdown-item dropdown-toggle" href="#sidebar-cards" data-bs-toggle="dropdown" data-bs-auto-close="outside" role="button" aria-expanded="false">
                          User Manual
                          </a>
                          <div className="dropdown-menu">
                          <a onClick={() => DownloadFile()} className="dropdown-item">
                              Instruction Manual
                            </a><a href="./userTrainings" className="dropdown-item">
                              Training Videos
                            </a>
                          </div>
                        </div>
                      
                      </div>
                    
                    </div>
                  </div>
                 
     </li>
     {user?.roleId ===2 && (
       <NavigationMenu.Item href="/userManagement" icon={<IconUsers />} label="User Management" />
     ) }
      {/* <NavigationMenu.Item href="/userManagement" icon={<IconUsers />} label="User Management" /> */}
    
     

    </>
  );
};

export default MenuItems;
